import type { UserProfile } from "@/interfaces/profile";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface ProfileState {
  profile: UserProfile | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: ProfileState = {
  profile: null,
  isLoading: false,
  error: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    getProfileRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },

    getProfileSuccess: (state, action: PayloadAction<UserProfile>) => {
      state.isLoading = false;
      state.profile = action.payload;
      state.error = null;
    },

    getProfileFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    clearProfile: (state) => {
      //   state.isLoading = false;
      state.profile = null;
    },
  },
});

export const {
  getProfileRequest,
  getProfileSuccess,
  getProfileFailure,
  clearProfile,
} = profileSlice.actions;
export default profileSlice.reducer;
